import validate from "/opt/buildhome/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  auth: () => import("/opt/buildhome/repo/middleware/auth.ts"),
  guest: () => import("/opt/buildhome/repo/middleware/guest.ts")
}